import { SystemUserPaymentsService } from '../../services/systemUserPayments.service';

import { SystemUserPaymentsStore } from '../../stores/systemUserPayments.store';

export default async function loadSystemUserPayments(filters) {
  const data = await SystemUserPaymentsService.load(filters);

  SystemUserPaymentsStore.payments.set(data);
}
